
<template>
  <div class="gold-btn-box" v-if="userData.uid && userData.watch_progress < canGatTime">
    <div class="gold"  @click="getGold"></div>
    <div class="time" :class="{'no-filter':lastTime == 0}">
      <template v-if="lastTime == 0">
        {{getDict(70)}}
      </template>
      <template v-if="lastTime > 0">
        {{lastTime | formatDate('mm:ss')}}
      </template>
    </div>
    
  </div>
  
</template>

<script>

  import { bus, getDict, axios, webSocket } from '../common'
  import { mapState, mapGetters } from 'vuex'

  let timeStep = 0;

  export default {
    props:{
      alertFunction:{},
    },
    data(){
      return {
        waitTime:[1*60*1000,3*60*1000,6*60*1000],
        moneyList:[300, 800, 1100],
        // timeStep:0,
        canGatTime:9,
      }
    },
    computed:{
      ...mapState(['userData','goingTime']),
      needTime(){
        return this.waitTime[this.userData.watch_progress % this.waitTime.length];
      },
      lastTime(){
        if(this.needTime > this.goingTime - timeStep){
          return this.needTime - (this.goingTime - timeStep);
        }else{
          return 0;
        }
      }
    },
    watch:{
    },
    components: {
    },
    methods: {
      getDict, 
      async getGold(){
        // console.log(123123)
        if(this.lastTime){
          if(this.alertFunction && typeof this.alertFunction == 'function'){
            let tips = this.$filters.formatDict(getDict(93),{
              waitTime:this.$filters.formatDate(this.lastTime,'mm:ss'),
              money:this.moneyList[this.userData.watch_progress % this.moneyList.length]
            })
            this.alertFunction(tips);
          }
          return;
        }
        let res = await webSocket.get('/user/get_watch_reward',{
        });
        timeStep = this.goingTime;
        this.$store.dispatch('getUserData');
        if(this.alertFunction && typeof this.alertFunction == 'function'){
          let str = getDict(72).replace(/\$\{[^\}]*\}/g,res.value);
          this.alertFunction(str);
        }
      },
    },
    mounted(){
    },
    created(){
    },
    beforeDestroy(){
    }
  }
</script>

<style lang="scss" scoped>
  .gold-btn-box{
    padding: 0.1rem 0;
    width: 0.7rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    .gold{
      display: inline-block;
      margin: auto;
      background: no-repeat center center;
      background-image: url(~@/assets/gold-btn.png);
      background-size: 100% 100%;
      width: .43rem;
      height: .43rem;
      position: relative;
      border-radius: 50%;
      box-shadow:0 0 0.1rem rgba(255, 196, 79,0.5);
      &.disabled{
        filter:grayscale(100%);
      }
    }
    .time{
      display: inline-block;
      margin: auto;
      margin-top: 0.03rem;
      $font-size: 0.12rem;
      font-size: $font-size;
      line-height: $font-size * 1.2;
      padding:0.03rem 0.07rem;
      border-radius: 1rem;
      color: #ffc44f;
      box-shadow:0 0 0.1rem rgba(255, 196, 79,0.5);

      &.no-filter{
        box-shadow:none;
      }
    }

    
  }
</style>
